import type { Reference } from '../../../../../models';
import type { CommandBody } from '../CrossOriginMessage';
import type { EntityChanged } from './shared/entity-changed';

/**
 * Indicates that the entity of reference was created.
 */
export class EntityCreatedCommandBody implements CommandBody {
  /**
   * Created entity.
   */
  entityChanged: EntityChanged;
  fieldValue: Reference | string;
  sourceReference: Reference | string;
  sourceFieldPath: string;
}
